<template>
  <!-- 正式客户 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button class="topAn" type="primary" size="mini" plain @click="add">
          <i class="el-icon-plus"></i>
          新增正式客户
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-input
            v-model="name"
            placeholder="请输入公司名称"
            clearable
            @change="search"
          />
        </div>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column prop="nickname" label="名称"> </el-table-column>
          <el-table-column align="right" label="操作" width="100px">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <template>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="删除用户后用户将无法登陆。确定删除该用户吗？"
                  @confirm="handleDelete(scope.$index, scope.row)"
                >
                  <el-button
                    class="danger_btn_text"
                    slot="reference"
                    size="mini"
                    type="text"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />
    </div>
    <div class="null_page" v-else>没有操作权限</div>

    <EditDialog
      v-model="editDialogShow"
      :dialogTop="dialog_top"
      :isAdd="isAdd"
    />
  </div>
</template>

<script>
import mixins from "../../../../mixins";
import EditDialog from "./components/editDialog.vue";

export default {
  mixins: [mixins],
  components: {
    EditDialog
  },
  data() {
    return {
      name: "",
      editDialogShow: false,
      isAdd: true
    };
  },
  methods: {
    // 获取列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.appUser_list,
        data: {}
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.total = res.data.total;
            this.tableData = res.data.concent;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 点击新增
    add() {
      this.isAdd = true;
      this.editDialogShow = true;
    },
    // 筛选
    search() {},
    // 点击编辑
    handleEdit() {
      this.isAdd = false;
      this.editDialogShow = true;
    },
    // 删除
    handleDelete() {}
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/riskViews/formalUser/index.vue